
import Vue from 'vue';
import _trim from 'lodash/trim';
import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.snow.css';
import Quill from 'quill';
import { getShowTextCounterAt } from '@/utils';

export default Vue.extend({
	name: 'HtmlField',
	components: {
		quillEditor,
	},
	props: {
		label: { type: String, required: true },
		value: { type: String, default: null },
		disabled: { type: Boolean, default: false },
		required: { type: Boolean, default: false },
		rules: { type: Array, default: null },
		maxLength: { type: Number, default: 10000 },
		allowLinks: { type: Boolean, default: false },
	},
	data () {
		return {
			plainText: '',
		};
	},
	computed: {
		editorOptions () {
			return {
				theme: 'snow',
				modules: {
					toolbar: [
						['bold', 'italic', 'underline', 'strike', ...(this.allowLinks ? ['link'] : [])],
						// ['blockquote', 'code-block'], // the class styles don't seem to be working in the v-dompurify-html
						[{ 'header': 1 }, { 'header': 2 }],
						[{ 'list': 'ordered' }, { 'list': 'bullet' }],
						[{ 'script': 'sub' }, { 'script': 'super' }],
						[{ 'indent': '-1' }, { 'indent': '+1' }],
						[{ 'direction': 'rtl' }],
						[{ 'size': ['small', false, 'large', 'huge'] }],
						[{ 'header': [1, 2, 3, 4, 5, 6, false] }],
						[{ 'color': [] }, { 'background': [] }],
						[{ 'font': [] }],
						[{ 'align': [] }],
						['clean'],
					],
				},
			};
		},
		computedRules (): any {
			// For v-form validation, use array format if rules are provided, otherwise use default
			if (this.rules) {
				const rules = this.rules;
				if (this.required) {
					rules.concat(this.requiredRule);
				}
				rules.concat(this.maxLengthRule);
				return rules;
			}

			const rules = this.maxLengthRule;
			if (this.required) {
				rules.concat(this.requiredRule);
			}
			return rules;
		},
		requiredRule (): any[] {
			return [
				(v: any) => !!_trim(v) || 'Required',
			];
		},
		maxLengthRule (): any[] {
			return [
				(v: any) => this.plainText.length <= this.maxLength || `Must be less than ${this.maxLength} characters`,
			];
		},
	},
	methods: {
		getShowTextCounterAt,
		onEditorInput (value: string) {
			this.$emit('input', value);
		},
		onEditorReady (value: Quill) {
			this.plainText = value.getText();
		},
		onEditorChange (value: { html: string, text: string, quill: any }) {
			this.plainText = value.text;
		},
	}
});
